<template>
    <b-card
        no-body
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4>{{ $t('org.billing.Daily by Distribution Ids') }}</h4>
            </div>
        </div>
        <div
            ref="REF_CLOUDFRONT_LINE"
            class="py-2"
        >
            <LineChart
                :data="chartData"
                :options="chartOptions"
                :height=300
            ></LineChart>
        </div>
    </b-card>
</template>

<script>
import { getCurrentInstance, computed, toRefs } from '@vue/composition-api'
import createVueChart from '@/components/CreateVueChart'
import formattedDate from '@/utils/formattedDate'
export default {
    components: {
        LineChart: createVueChart('Line')
    },
    props: {
        yKeys: {
            type: Array,
            default: function () {
                return []
            }
        },
        data: {
            type: Array,
            default: function () {
                return []
            }
        },
        themeColors: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const { yKeys, data, themeColors } = toRefs(props)
        const noData = computed(() => !data.value.length)
        const distributionConvertId = (resourceId) => {
            const convertId = resourceId.split('distribution/')
            if (convertId.length > 1) {
                return convertId[1]
            } else {
                return convertId[0]
            }
        }
        const lang = computed(() => vm.$i18n.locale)
        const gDataValueMap = computed(() => {
            return data.value.reduce((accumulator, currentValue) => {
                accumulator[currentValue.date] = currentValue.resources.reduce((accumulator, currentValue) => {
                    const key = distributionConvertId(currentValue.resourceId)
                    accumulator[key] = currentValue.cost
                    if (typeof accumulator.sum === 'number') {
                        accumulator.sum += currentValue.cost
                    } else {
                        accumulator.sum = currentValue.cost
                    }
                    return accumulator
                }, {})
                return accumulator
            }, {})
        })
        const chartData = computed(() => {
            return {
                type: 'line',
                labels: data.value.map(item => item.date),
                datasets: yKeys.value.map((key, index) => {
                    return {
                        spanGaps: false,
                        label: key,
                        backgroundColor: 'transparent',
                        borderColor: themeColors.value.range[index % themeColors.value.range.length],
                        data: data.value.map(item => gDataValueMap.value[item.date][key] ?? NaN)
                    }
                })
            }
        })
        const getYData = label => label < 1 ? vm.$_getDollar(label, 3) : vm.$_getDollar(label, 0)
        const chartOptions = {
            legend: {
                display: false
            },
            plugins: {
                noDataBackground: {
                    display: true,
                    imageSrc: require('@/assets/images/empty.png'),
                    text: vm.$t('org.dashboard.No data')
                },
                datalabels: {
                    display: false
                }
            },
            responsive: true,
            tooltips: {
                mode: 'index',
                shadowOffsetX: 1,
                shadowOffsetY: 1,
                shadowBlur: 8,
                callbacks: {
                    label: (tooltipItem, { datasets }) => {
                        const dataName = datasets[tooltipItem.datasetIndex].label
                        const dataValue = gDataValueMap.value[tooltipItem.label][dataName]
                        return `${dataName} : ${vm.$_getDollar(dataValue, 2)}`
                    }
                }
            },
            maintainAspectRatio: false,
            scales: {
                xAxes: [
                    {
                        ticks: {
                            display: true,
                            callback: value => formattedDate(lang.value, value, 'month-day')
                        }
                    }
                ],
                yAxes: [
                    {
                        ticks: {
                            beginAtZero: true,
                            count: 5,
                            maxTicksLimit: 5,
                            callback: getYData
                        },
                        scaleLabel: {
                            display: true
                        }
                    }
                ]
            }
        }
        return {
            noData,
            gDataValueMap,
            distributionConvertId,
            chartOptions,
            chartData
        }
    }
}
</script>

<style>

</style>
